import { css } from '@emotion/core'
import { measures } from 'styles/variables'
import * as MEDIA from 'styles/media-queries'

const { unit } = measures

export const confirmSection = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  min-width: ${50 * unit}px;

  border-radius: ${unit}px;

  padding: ${3 * unit}px;

  ${MEDIA.PHONES} {
    width: 100%;
  }
`
